export const getFunctionBody = (fn) => {
  if (typeof fn !== 'function') {
    throw new TypeError('Argument must be a function');
  }

  const str = fn.toString();

  // Handle arrow functions with implicit return (no braces)
  if (!str.includes('{')) {
    return str.split('=>')[1].trim();
  }

  // Extract between the first { and the last }
  return str.substring(str.indexOf('{') + 1, str.lastIndexOf('}')).trim();
};

export function generateRandomString(length) {
  return Math.random().toString(36).substring(2, 2 + length);
}
